export default function Dashboard() {
  return (
    <div className="container-fluid">
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">DASHBOARD</h1>
        <button 
          className="btn btn-sm btn-primary"
        >
          <i className="fas fa-sync-alt"></i> Refresh
        </button>
      </div>
    </div>
  );
}